import { render, staticRenderFns } from "./cabinet-quotations-list.vue?vue&type=template&id=d639c868&scoped=true&"
import script from "./cabinet-quotations-list.vue?vue&type=script&lang=js&"
export * from "./cabinet-quotations-list.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-quotations-list.vue?vue&type=style&index=0&id=d639c868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d639c868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d639c868')) {
      api.createRecord('d639c868', component.options)
    } else {
      api.reload('d639c868', component.options)
    }
    module.hot.accept("./cabinet-quotations-list.vue?vue&type=template&id=d639c868&scoped=true&", function () {
      api.rerender('d639c868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/quotation-requests/cabinet-quotations-list.vue"
export default component.exports